// Tiny typed event emitter. The UI is instrumentation over the engine: it
// subscribes to these events; the engine never knows the UI exists.

import { TableMeta } from "./types";
import { Trace } from "./trace";

export type EngineEvent =
  | { type: "write"; key: string; op: "put" | "delete"; seq: number }
  | { type: "memtable"; bytes: number; count: number; limit: number }
  | { type: "flush-start"; entryCount: number; bytes: number }
  | { type: "flush-end"; table: TableMeta }
  | {
      type: "compaction-start";
      strategy: "leveled" | "tiered";
      fromLevel: number;
      toLevel: number;
      inputTables: number[];
    }
  | {
      type: "compaction-progress";
      /** Entries merged so far / total input entries. */
      done: number;
      total: number;
    }
  | {
      type: "compaction-end";
      fromLevel: number;
      toLevel: number;
      inputTables: number[];
      outputTables: TableMeta[];
      droppedTombstones: number;
      bytesWritten: number;
    }
  | { type: "manifest" }
  /** A completed operation with the steps the engine actually executed. */
  | { type: "trace"; trace: Trace }
  | { type: "recovered"; walRecords: number; tables: number };

export type Listener = (e: EngineEvent) => void;

export class Emitter {
  private listeners = new Set<Listener>();

  on(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  emit(e: EngineEvent): void {
    for (const fn of this.listeners) fn(e);
  }
}
